import React from 'react';

const TotalPrice = () => {
    return (
        <div className="total-price-wrapper xmt-8 xmt-lg-16">
            <div className="inputs-discount-payment d-block d-lg-none">
                <div className="payment-input">
                    <span className="text">شیوه پرداخت</span>
                    <span className="value">پرداخت اینترنتی</span>
                </div>
                <div className="discount-input xmt-2">
                    <span className="text">کادو و کد تخفیف</span>
                    <span className="value">ندارم</span>
                </div>
                <div className="small-text position-absolute">کد تخفیف 098788 اعمال شد</div>
            </div>
            <div className="price-factor xmt-8 xmt-lg-0">
                <div className="inputs-discount-payment d-none d-lg-block">
                    <div className="row">
                        <div className="col-6">
                            <div className="payment-input">
                                <span className="text">شیوه پرداخت</span>
                                <span className="value">پرداخت اینترنتی</span>
                            </div>
                        </div>
                        <div className="col-6 position-relative">
                            <div className="discount-input">
                                <span className="text">کادو و کد تخفیف</span>
                                <span className="value">ندارم</span>
                            </div>
                            <div className="small-text position-absolute">کد تخفیف 098788 اعمال شد</div>
                        </div>
                    </div>
                </div>
                <ul className="info-factor list-unstyled persian-number xmt-4">
                    <li className="d-flex align-items-center justify-content-between">
                        <span className="text">شماره سفارش</span>
                        <span className="value">554433</span>
                    </li>
                    <li className="d-flex align-items-center justify-content-between">
                        <span className="text">جمع اقلام</span>
                        <span className="value">۸۰,۰۰۰ ت</span>
                    </li>
                    <li className="d-flex align-items-center justify-content-between">
                        <span className="text">هزینه ارسال</span>
                        <span className="value">پس‌کرایه</span>
                    </li>
                    <li className="d-flex align-items-center justify-content-between">
                        <span className="text">تخفیف</span>
                        <span className="value red-price">۸۰,۰۰۰ ت</span>
                    </li>
                </ul>
                <ul className="price-info list-unstyled persian-number">
                    <li className="d-flex align-items-center justify-content-between">
                        <span className="text">جمع کل</span>
                        <span className="value">۵۷,۲۶۸,۰۰۰ ت</span>
                    </li>
                    <li className="d-flex align-items-center justify-content-between">
                        <span className="text">مبلغ پرداخت شده</span>
                        <span className="value">۵۷,۲۶۸,۰۰۰ ت</span>
                    </li>
                    <li className="d-flex align-items-center justify-content-between">
                        <span className="text blue-bold-text">مبلغ باقی مانده</span>
                        <span className="value blue-bold-text">۵۷,۲۶۸,۰۰۰ ت</span>
                    </li>
                </ul>
            </div>
            <div className="payment-status xmt-4 xmt-lg-6">
                <ul className="status list-unstyled persian-number">
                    <li className="d-flex align-items-center justify-content-between">
                        <span className="text blue-bold-text">شماره تراکنش</span>
                        <span className="value blue-bold-text">64105</span>
                    </li>
                    <li className="d-flex align-items-center justify-content-between">
                        <span className="text blue-bold-text">مبلغ تراکنش</span>
                        <span className="value blue-bold-text">۵۰,۰۰۰,۰۰۰  ت</span>
                    </li>
                    <li className="d-flex align-items-center justify-content-between">
                        <span className="text blue-bold-text">وضعیت تراکنش</span>
                        <span className="value blue-bold-text">در انتظار پرداخت</span>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default TotalPrice;
